export const HAIRDRESSING_OFFER_ID = "january-hairdressing" as const;
export const HAIRDRESSING_DETAIL_ID = "5068530c-69f4-4f4f-964d-e10b72143b28";
export const HAIRDRESSING_JANUARY_EVENT_ID = "eff884a3-06b2-51c4-8967-cac47baf8951";
export const HAIR_EXTENSION_DETAIL_ID = "d23ce866-63a9-4dcc-a09f-6540ec60405a";
export const HAIR_EXTENSION_TITLE = "Complete Hair Extension and Styling Mastery Course";
export const HAIRDRESSING_OFFER_EX_VAT_PENCE = 250_000;
export const HAIRDRESSING_OFFER_INC_VAT_PENCE = 300_000;

export function isJanuaryHairdressingEvent(event: { id?: string; detail_id?: string } | null | undefined): boolean {
  return event?.id === HAIRDRESSING_JANUARY_EVENT_ID &&
    (!event.detail_id || event.detail_id === HAIRDRESSING_DETAIL_ID);
}
